import * as React from "react";
import { IPrayerState } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Prayer/Prayer";
import { ShowPreviousPrayer } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Prayer/History/Previous/ShowPreviousPrayer";

export function PrayerHistory({ state }: { state: IPrayerState }) {
    if (state.bodyTexts.length === 0) {
        return null;
    }

    const itemsToShow = state.bodyTexts.slice(-numPrevItemsToShow);

    const opacityBoost =
        itemsToShow.length < numPrevItemsToShow
            ? (numPrevItemsToShow - itemsToShow.length) / 10
            : 0;

    return (
        <div
            style={{
                textAlign: `center`,
                margin: "15px 20px 0px 20px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
            }}
        >
            {itemsToShow.map((text, index) => (
                <ShowPreviousPrayer
                    key={`${index}_${text}`}
                    {...{ text, opacity: 0.2 + index / 10 + opacityBoost }}
                />
            ))}
        </div>
    );
}

const numPrevItemsToShow = 8;
